var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{staticStyle:{"position":"relative"},style:({ maxHeight: _vm.height, minHeight: _vm.height, width: _vm.width}),attrs:{"id":_vm.id,"options":_vm.chartOptions,"data":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }